/* eslint-disable import/max-dependencies */
import React from "react";
import { Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import NotificationsComponent from "@fas/cpa-cabinet-ui/lib/Notifications";
import withNotifications from "@fas/cpa-state-manager/services/notifications";
import { withStyles } from "@mui/styles";
import { Paper } from "@mui/material";
import configureStore from "./store";
import { openZoneBackgroundStyles } from "../../styles";

const Background = withStyles(openZoneBackgroundStyles)(Paper);
const Notifications = withNotifications(NotificationsComponent);
const store = configureStore();

export const serviceRoutes: string[] = ["/unsubscribe/:token"];

// eslint-disable-next-line react/function-component-definition
const Service = () => (
  <Provider store={store}>
    <Notifications />
    <Background>
      <Outlet />
    </Background>
  </Provider>
);

export default Service;
